import { configuredSyncsResource } from '../configured-syncs/resources';
import { isCurrentSiteSyncEnabledResource } from '../is-current-site-sync-enabled-resource';
import { getTeamResource } from '../team-resource';
import { userAccessRightsResource } from '../user-access-rights/resources';

export const resources = {
	configuredSyncsResource,
	userAccessRightsResource,
	getTeamResource,
	isCurrentSiteSyncEnabledResource,
};
